import { UPDATE_TEST_DURATION } from '../constants/actionTypes'

export default (state = {}, action) => {
    switch (action.type) {
        case UPDATE_TEST_DURATION:
            return action.payload
        default:
            return state
    }
}
